"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
exports.TaskSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.ConvertRangeConfigSchema.extend({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('convertRange'),
        srcArtifactSlug: zod_1.z.string(),
    }),
    zod_1.z.object({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('extractValues'),
        extract: zod_1.z.array(tape_sanitizer_1.ExtractValueConfigSchema),
        srcArtifactSlug: zod_1.z.string(),
    }),
]);
exports.UiConfigSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.ConvertRangeConfigSchema.extend({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('convertRange'),
    }),
    zod_1.z.object({
        operation: zod_1.z.literal('xlsx2csv'),
        mode: zod_1.z.literal('extractValues'),
        extract: zod_1.z.array(tape_sanitizer_1.ExtractValueConfigSchema),
    }),
]);
exports.nodeType = 'operation_xlsx2csv';
//# sourceMappingURL=types.js.map